import React, {useCallback, useState} from 'react';
import {Button, Container, Col, Row} from 'reactstrap';

import Modal from 'components/Modal';
import ModalContext from 'contexts/modal';
import CheckoutButton from 'components/CheckoutButton';
import classNames from 'classnames';
import ShowIf from 'funnel-schedule/ShowIf';
import useExitIntent from 'utils/useExitIntent';

export default function ModalExitScreening({children, ...props}) {
  const {isOpen, toggle} = useExitIntent(30000);

  return (
    <Modal className="modal-exit-intent" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="order-lg-2 py-5 my-auto">
          <h2 className="text-condensed text-800">
            Don't have time to <br className="d-none d-sm-block" />
            watch it all now?
          </h2>
          <p className="mb-0">
            For a limited time, you can support our <br className="d-none d-sm-block" />
            mission and own a personal copy of <br className="d-none d-sm-block" />
            <em>The Need To GROW</em> for life, <br className="d-none d-sm-block" />
            for <strong>just $7 right now!</strong>
          </p>
          <Row className="d-flex justify-content-center wrapper pb-0">
            <Col xs="12" sm="10" md="8">
              <CheckoutButton
                className="btn-block text-uppercase text-white text-condensed text-800 text-h4"
                sku="tntg"
                price="7"
                slug="tntg-special"
                target="_blank"
              >
                Claim Your Offer Now
              </CheckoutButton>
            </Col>
          </Row>
        </Col>
        <Col xs="12" lg="5" className="exit-modal-image-col order-lg-1">
          <div className="exit-modal-image background-image-sitting-sunset" />
        </Col>
      </Row>
    </Modal>
  );
}
